module.exports = __webpack_public_path__ + "img/empty_box.b9b143ac.png";